import { render, staticRenderFns } from "./StatsTotalAmount.vue?vue&type=template&id=26963b0e&"
import script from "./StatsTotalAmount.vue?vue&type=script&lang=js&"
export * from "./StatsTotalAmount.vue?vue&type=script&lang=js&"
import style0 from "./StatsTotalAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports